import { FavoriteReference, ID } from '@griply/types';

export const removeFromFavoriteList = (
  favorites: FavoriteReference[],
  ids: ID[],
): FavoriteReference[] =>
  favorites.filter((favorite) => !ids.includes(favorite.id));
